import { Tab } from './Tab';
import styles from './Tab.module.scss';

interface TabsProps {
  tabs: { value: string; label: string }[];
  value?: string;
  onChange: (event: React.SyntheticEvent, newValue: any) => void;
}

export const Tabs = ({ tabs, value, onChange }: TabsProps) => {
  const tabList = tabs.map((tab, i) => {
    const { label, value: tabsValue } = tab;
    return <Tab key={i} label={label} control={tabsValue} selected={tabsValue === value} onClick={onChange} />;
  });

  return (
    <div role="tablist" className={styles.tab_list}>
      {tabList}
    </div>
  );
};
